/** Special sizes used in certain circumstances */
const specialSizes = {
	TRIAL: 15,
	FREE_PLAN: 50,
	LEGACY: 9999,
	BIG_DATA: 65535, // Max `smallint` value
} as const;

export default specialSizes;
